<template>
  <div :class="['example-content', {'anchor-page-example-content': isIndented}]">
    <button
      class="text-left btn-block content-indent"
      role="button"
      type="button"
      :aria-expanded="expandFooter ? 'true' : 'false'"
      @click="clickedFooter"><slot name="label">Examples</slot> <i
        aria-hidden="true"
        class="fa fa-2x fa-angle-down"
        :class="{'fa-rotate-180': expandFooter}" /></button>
    <collapse
      v-model="expandFooter"
      :transition="200"
      class="collapse-spacing"
    >
      <slot/>
    </collapse>
  </div>
</template>

<script>
export default {
  name: 'GoalExampleContent',
  props: {
    initiallyExpand: {
      type: Boolean,
      default: false
    },
    isIndented: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      expandFooter: this.initiallyExpand
    }
  },
  methods: {
    clickedFooter() {
      this.expandFooter = !this.expandFooter
      this.$emit('toggle', this.expandFooter)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
button {
  height: 40px;
  position: relative;
  border: 0;
  background-color: @background-light-gray;
  padding: 0 17px;
  font-weight: bold;
  font-size: 1.142em;
  color: #636363;


  .fa-angle-down {
    position: absolute;
    right: 17px;
    top: 50%;
    margin-top: -14px;
  }

  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}

.collapse,
.collapsing {
  padding: 21px 15px 15px 15px;
}

.anchor-page-example-content {
  .content-indent {
    padding-left: 64px;
  }
  .collapse-spacing {
    margin-top: -6px;
  }
}
</style>
